"use client";

const WATCHED_SPECIALS_KEY = "punchup_watched_specials";
const PLAYED_EXTRA_KEY = "punchup_played_extra_from";
export const AUTOPLAY_QUEUE_KEY = "punchup_autoplay_queue";
const CAME_FROM_AUTOPLAY_KEY = "punchup_came_from_autoplay";

export function getWatchedSpecials(): string[] {
  try {
    if (typeof window === "undefined") return [];
    const data = localStorage.getItem(WATCHED_SPECIALS_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.error("Error reading watched specials:", e);
    return [];
  }
}

export function addToWatchedSpecials(specialId: string): void {
  try {
    if (!specialId || typeof window === "undefined") return;
    const watched = getWatchedSpecials();
    if (!watched.includes(specialId)) {
      watched.push(specialId);
      localStorage.setItem(WATCHED_SPECIALS_KEY, JSON.stringify(watched));
    }
  } catch (e) {
    console.error("Error adding to watched specials:", e);
  }
}

export function cameFromAutoplay(): boolean {
  try {
    if (typeof window === "undefined") return false;

    const fromAutoplay =
      localStorage.getItem(CAME_FROM_AUTOPLAY_KEY) === "true";

    localStorage.removeItem(CAME_FROM_AUTOPLAY_KEY);

    return fromAutoplay;
  } catch (e) {
    console.error("Error checking if came from autoplay:", e);
    return false;
  }
}

export function setComingFromAutoplay(): void {
  try {
    if (typeof window === "undefined") return;
    localStorage.setItem(CAME_FROM_AUTOPLAY_KEY, "true");
  } catch (e) {
    console.error("Error setting coming from autoplay:", e);
  }
}

export function clearComingFromAutoplay() {
  try {
    if (typeof window !== "undefined") {
      localStorage.removeItem(CAME_FROM_AUTOPLAY_KEY);
    }
  } catch {}
}

// Applies to any explicit nav to a comedian page (outside of autoplay)
// We will autoplay one extra from this comedian before using the autoplay queue
// These need to use sessionStorage not localStorage
export function hasPlayedExtraFromComedian(comedianId: string): boolean {
  try {
    if (!comedianId || typeof window === "undefined") return false;
    const data = sessionStorage.getItem(PLAYED_EXTRA_KEY);
    const played = data ? JSON.parse(data) : {};
    return !!played[comedianId];
  } catch (e) {
    console.error("Error checking played extra:", e);
    return false;
  }
}

export function markPlayedExtraFromComedian(comedianId: string): void {
  try {
    if (!comedianId || typeof window === "undefined") return;
    const data = sessionStorage.getItem(PLAYED_EXTRA_KEY);
    const played = data ? JSON.parse(data) : {};
    played[comedianId] = true;
    sessionStorage.setItem(PLAYED_EXTRA_KEY, JSON.stringify(played));
  } catch (e) {
    console.error("Error marking played extra:", e);
  }
}

export function resetPlayedExtraForComedian(comedianId: string): void {
  try {
    if (!comedianId || typeof window === "undefined") return;
    const data = sessionStorage.getItem(PLAYED_EXTRA_KEY);
    const played = data ? JSON.parse(data) : {};
    delete played[comedianId];
    sessionStorage.setItem(PLAYED_EXTRA_KEY, JSON.stringify(played));
  } catch (e) {
    console.error("Error resetting played extra:", e);
  }
}
